import { render, staticRenderFns } from "./rewardInfo.vue?vue&type=template&id=08bb7bf9&scoped=true&"
import script from "./rewardInfo.vue?vue&type=script&lang=js&"
export * from "./rewardInfo.vue?vue&type=script&lang=js&"
import style0 from "./rewardInfo.vue?vue&type=style&index=0&id=08bb7bf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb7bf9",
  null
  
)

export default component.exports